import React from 'react'

import { ReactComponent as FolderClosedIcon } from '@sketch/icons/folder-closed-17'
import { ReactComponent as FolderOpenIcon } from '@sketch/icons/folder-open-17'
import { ReactComponent as LockIcon } from '@sketch/icons/lock-closed-17'
import { ReactComponent as PeopleIcon } from '@sketch/icons/persons-2-17'
import { ProjectInSidebarAndHeaderFragment } from '@sketch/gql-types'
import { ReactComponent as MyDraftsProject } from '@sketch/icons/notes-17'

export interface ProjectIconProps {
  project: Partial<ProjectInSidebarAndHeaderFragment>
  isOpen?: boolean
}

export const ProjectIcon = (props: ProjectIconProps) => {
  const { project, isOpen } = props

  if (project.projectType === 'PERSONAL_DRAFTS') {
    return <MyDraftsProject />
  }

  switch (project.projectPrivacyIcon) {
    case 'GUESTS':
      return <PeopleIcon />

    case 'INVITED_WORKSPACE_MEMBERS':
      return <LockIcon />

    case 'WORKSPACE_MEMBERS':
    default:
      if (isOpen) {
        return <FolderOpenIcon />
      } else {
        return <FolderClosedIcon />
      }
  }
}
